import { useUser } from '@ad-lucy/gateway-provider';
import {
  useFetchBirthdaysCountGqlQuery,
  useFetchCompaniesCountGqlQuery,
  useFetchContactsCountGqlQuery,
} from '@codegen';
import { isNonNullable } from '@modules/utils';
import NavBarItem from './NavBarItem';
import NavBarMenu from './NavBarMenu';
import { NavigationItem } from './nav.utils';

export const birthdaysQueryVariables = {
  variables: {
    where: {
      birthday: { ne: null },
    },
  },
};

export function CrmNavBarMenu() {
  const user = useUser();
  const companiesCountQueryResult = useFetchCompaniesCountGqlQuery();
  const contactsCountQueryResult = useFetchContactsCountGqlQuery();
  const birthdaysCountQueryResult = useFetchBirthdaysCountGqlQuery(
    birthdaysQueryVariables,
  );

  const children = [
    user.require('customer:get') ? (
      <NavBarItem
        nested={true}
        key={NavigationItem.CRM_COMPANIES}
        id={NavigationItem.CRM_COMPANIES}
        name={NavigationItem.CRM_COMPANIES}
        icon="IconBuilding"
        paths={['/crm/accounts/*']}
        link="/crm/accounts"
        badge={{
          loading: companiesCountQueryResult.loading,
          value: companiesCountQueryResult.data?.accounts?.totalCount,
        }}
      />
    ) : null,
    user.require('account.person:view') ? (
      <NavBarItem
        nested={true}
        key={NavigationItem.CRM_CONTACTS}
        id={NavigationItem.CRM_CONTACTS}
        name={NavigationItem.CRM_CONTACTS}
        icon="IconUser"
        paths={['/crm/contacts/*']}
        link="/crm/contacts"
        badge={{
          loading: contactsCountQueryResult.loading,
          value: contactsCountQueryResult.data?.contacts?.totalCount,
        }}
      />
    ) : null,
    user.require('account.person:view') ? (
      <NavBarItem
        nested={true}
        key={NavigationItem.CRM_BIRTHDAYS}
        id={NavigationItem.CRM_BIRTHDAYS}
        name={NavigationItem.CRM_BIRTHDAYS}
        paths={['/crm/birthdays/*']}
        link="/crm/birthdays"
        icon="IconCalendar"
        badge={{
          loading: birthdaysCountQueryResult.loading,
          value: birthdaysCountQueryResult.data?.contacts?.totalCount,
        }}
      />
    ) : null,
  ].filter(isNonNullable);

  return children.length ? (
    <NavBarItem
      key={NavigationItem.CRM_CUSTOMER}
      id={NavigationItem.CRM_CUSTOMER}
      name={NavigationItem.CRM_CUSTOMER}
      icon="IconBookOpen"
      paths={['/crm/*']}
      link="/crm/accounts"
    >
      <NavBarMenu nested={true} itemCount={children.length}>
        {children}
      </NavBarMenu>
    </NavBarItem>
  ) : null;
}
